import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/iconfont/iconfont.css'
import '@/utils/animate.css'

//引入MintUi组件
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)

//引入vuex的store
import store from './store'

//引入axios
import axios from 'axios'
Vue.prototype.axios = axios;

//引入滚动轮播组件
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

//引入css的重置样式
import '@/utils/reset.css'

//引入js的rem布局
import './utils/rem'


//路由守卫的一些操作
router.beforeEach((to, from, next) => {
   
    if (to.matched.length) {
        //根据字段判断是否路由过滤
        if (to.matched.some(record => record.meta.auth)) {
           //判读是否有token
            if (window.localStorage.getItem('token') !== null) {
                //判断是为业主
                if(JSON.parse(localStorage.getItem('isMaster'))){
                    //判断路由名字是否为业主的
                    if(!['HomeMaster','FindMaster','FindMaster_office','FindMaster_znz','ProjectDetailsMaster','ProjectNodeMaster','SetbaseMessMaster',
                    'ProjectMemberMaster','ContractMoneyMaster','CollectionStatusMaster','IncreaseorDecreaseMaster','PhotoFileMaster','MemorandumMaster','SiteSignMaster'].includes(to.name)){
                        next('/homeMaster')
                    }
                }
                next()
            } else {
                //防止无限循环
                if (to.name === 'Login') {
                    next();
                    return
                }
                next();
            }
        } else {
            next()//若点击的是不需要验证的页面,则进行正常的路由跳转
        }
    }else{
        next({
            path: '/login',
        })
    }

});










Vue.config.productionTip = false


new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js